<template>
  <div class="modal email-inpanel">
    <div class="modal_content">
      <div class="modal_header">
        <h1 class="modal_title">{{ subject }}</h1>
        <span class="modal_close" @click="close()">&times;</span>
      </div>
      <div class="modal_body">
        <div v-for="(email,idx) in reversedEmails" :key="email.email_message_id" class="email-message">
          <EmailMessage :email="email" :index="idx" :Emails="reversedEmails"/>
          <div v-if="idx !== reversedEmails.length - 1" class="email-divider"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import EmailMessage from "./EmailMessage.vue";

export default {
 name: "Email",
 data: () => ({
  replyActivated: false,
 }),

  computed: {
    reversedEmails() {
      return [...this.Emails].reverse();
    }
  },

 components: {
    EmailMessage,
},
 props: {
  subject: String,
  Emails: Array
 },
 methods: {
  ...mapActions("frontdesk",["hideThreads"]),
  close() {
   this.hideThreads();
   this.replyActivated = false;
  },
 }
}
</script>


<style scoped>
.modal.email-inpanel {
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  background: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
}
.modal_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  border-radius: 8px;
  border: 1px solid #ccc;
}
.modal_header {
  flex: 0 0 auto;
  padding: .5em 1em;
  border-bottom: 1px solid #eee;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal_title {
  font-size: 1.5rem;
  text-align: left;
}
.modal_close {
  cursor: pointer;
}
.modal_body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1em;
  text-align: left;     /* all content left aligned */
}
.email-message {
  margin-bottom: 1em;
}
.email-divider {
  border-bottom: 1px solid #ddd;
  margin: 10px 0;
}
</style>